export default __webpack_public_path__ + "static/media/team1a.09832050.JPG";